export default __webpack_public_path__ + "static/media/google_chat.01420f50.mp3";